import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useOfferingSidePanelMatch } from '../hooks/useOfferingSidePanelMatch';

export const useCloseSidePanel = () => {
  const navigate = useNavigate();

  const sidePanelMatch = useOfferingSidePanelMatch();

  const closeSidePanel = React.useCallback(() => {
    if (sidePanelMatch) navigate(sidePanelMatch.basePathname);
  }, [sidePanelMatch, navigate]);

  return {
    sidePanelMatch,
    closeSidePanel,
  };
};
